import Wrapper from "../../../layout/Wrapper";
import WebMenuManagerComponent from "../../../screens/settings/web-menu";
import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Web Menu Management",
	description: "Manage website menus, pages and permission buttons",
};

export default function WebMenuManager() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<WebMenuManagerComponent />
		</Wrapper>
	);
}
